import {Button, Menu, MenuItem} from '@material-ui/core';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';
import {EnrollmentRouteConstants} from 'Enrollment/Routes';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import MenuStateProvider from 'Shared/components/MenuStateProvider';
import RequireAtLeastOneScope from 'Shared/components/RequireAtLeastOneScope';
import {EnrollmentDiscrepantStatus} from 'Shared/constants/EnrollmentDiscrepantStatus';
import RequireScope from 'Shared/components/RequireScope';
import {Scope} from 'Shared/constants/Scope';
import {hasScopeToViewEtsAdminDashboard} from '../Dashboard/LineOfBusinessDashboard';

type EnrollTrackMenuProps = {
  scopes: Scope[];
} & RouteComponentProps;

export const EnrollTrackMenu = (props: EnrollTrackMenuProps) => (
  <RequireAtLeastOneScope scopes={[Scope.SearchEnrollmentFiles]}>
    <MenuStateProvider>
      {({open, close, anchor}) => (
        <>
          <Button
            id="administration-menu-button"
            className="my-access-menu"
            variant="text"
            onClick={event => open(event.currentTarget)}
          >
            Enrollment Processing
            <ArrowDown />
          </Button>
          <Menu
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            transformOrigin={{vertical: 'top', horizontal: 'center'}}
            getContentAnchorEl={null}
            onClose={close}
            open={Boolean(anchor)}
            anchorEl={anchor}
          >
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(
                  hasScopeToViewEtsAdminDashboard(props.scopes)
                    ? EnrollmentRouteConstants.ENROLLMENTS_ETS_ADMIN_DASHBOARD
                    : EnrollmentRouteConstants.ENROLLMENTS_DASHBOARD
                );
                close();
              }}
            >
              Dashboard
            </MenuItem>
            <RequireScope scopes={props.scopes} scope={Scope.SearchEnrollmentFiles}>
              <MenuItem
                className="my-access-menu__item"
                id="agent-administration-option"
                onClick={() => {
                  props.history.push(EnrollmentRouteConstants.ENROLLMENT_FILE_PROCESSING);
                  close();
                }}
              >
                Enrollment Files
              </MenuItem>
            </RequireScope>
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(EnrollmentRouteConstants.ENROLLMENT_FILE_ERRORS);
                close();
              }}
            >
              Enrollment File Errors
            </MenuItem>
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(EnrollmentRouteConstants.ENROLLMENT_FILES_NOT_PROCESSED);
                close();
              }}
            >
              Files Not Processed
            </MenuItem>
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(EnrollmentRouteConstants.EMPLOYER_ENROLLMENTS);
                close();
              }}
            >
              Account Enrollments
            </MenuItem>
            {process.env.REACT_APP_TOGGLE_UNSUCCESSFUL_PROCESSING === 'true' && (
            <RequireScope scopes={props.scopes} scope={Scope.UnsuccessfulProcessingRead}>
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(EnrollmentRouteConstants.EMPLOYER_ENROLLMENTS_DISCREPANT_DETAILS(EnrollmentDiscrepantStatus.Outstanding));
                close();
              }}
            >
              Unsuccessful Processing
            </MenuItem>
            </RequireScope>
            )}
            <MenuItem
              className="my-access-menu__item"
              id="agent-administration-option"
              onClick={() => {
                props.history.push(EnrollmentRouteConstants.EXTERNAL_UPLOAD_QUEUE);
                close();
              }}
            >
              Broker Spreadsheet Uploads
            </MenuItem>
          </Menu>
        </>
      )}
    </MenuStateProvider>
  </RequireAtLeastOneScope>
);

export default withRouter(EnrollTrackMenu);
